import React, {useEffect, useState} from 'react';
import { Table } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import {useLazyQuery} from '@apollo/client';
import _ from 'lodash';
import { useToasts } from "react-toast-notifications";

// component
import {GET_SUMMARY_MONEY} from '../../graphql/totalSummary/query';

const SummaryMoney = ({systems, pages, date, setIsLoading}) => {
    const { addToast } = useToasts();
    const [tableData, setTableData] = useState([]);
    //* Query ***
    const [getSummaryMoney, { data: summaryMoneyData, loading: loadingSummaryMoney }] = useLazyQuery(GET_SUMMARY_MONEY, {
        fetchPolicy: 'cache-and-network',
    });

    //* useEffect ***
    useEffect(() => {
        if(!_.isEmpty(systems?.amount)|| !_.isEmpty(pages?.amount) || !_.isEmpty(date.createdAt_lt)) {
            setTimeout(() => {
                handleSummaryMoney();
            }, 1000);
        }
    }, [systems, pages, date]);

    useEffect(() => {
        if(!_.isEmpty(summaryMoneyData)) {
            const summaryMoney = summaryMoneyData?.getSummaryMoney;
            const newSummaryMoney1 = JSON.parse(summaryMoney);
            if(newSummaryMoney1.length > 0) {
                setTableData(newSummaryMoney1);
            }
        }
    }, [summaryMoneyData]);

    useEffect(() => {
        if(loadingSummaryMoney) {
            setIsLoading((prev) => ({...prev, loadingSummaryMoney: true}));
        }
    }, [loadingSummaryMoney]);

    //* Function ****
    const handleSummaryMoney = async () => {
        if (loadingSummaryMoney) return;
        try {
            let where = {}
            if(!_.isEmpty(systems?.listName)) where = {...where, systems: systems?.listName.split(', ')};
            if(!_.isEmpty(pages?.listId)) where = {...where, pages: pages?.listId.split(', ')};
            if(!_.isEmpty(date?.createdAt_gte) && !_.isEmpty(date?.createdAt_lt)) {
                where = {...where, 
                    createdAt_gte: date?.createdAt_gte,
                    createdAt_lt: date?.createdAt_lt
                };
            }

            setTableData([]);
            await getSummaryMoney({variables: { where }});
            setIsLoading((prev) => ({...prev, loadingSummaryMoney: false}));
        } catch (error) {
            setTableData([]);
            setIsLoading((prev) => ({...prev, loadingSummaryMoney: false}));
            console.log("handleSummaryMoney error: ", error);
            if (error.message){
                console.log("1 handleSummaryMoney error: ", error.message);
                addToast("ບໍ່ພົບຂໍມູນ", {
                    appearance: "warning",
                    autoDismiss: true,
                });
            } else{
                console.log("2 handleSummaryMoney error: ", error.message);
                addToast("ມີຂໍຜີດຜາດທີ່ບໍ່ຄາດຄີດສຳລັບ ຍອດເງີນ", {
                    appearance: "error",
                    autoDismiss: true,
                });
            }
        }
    }

    // Data structure for the table
    // const tableData = [
    //     {
    //     currency: 'ກິບ', //ສະກຸນເງີນ:
    //     total: '1,000,000', //ຍອດທັງໝົດ:
    //     notYetPaid: '500,000', //ຍັງບໍ່ທັນຊຳລະ:
    //     paid: '500,000',  //ຊຳເລັດແລ້ວ
    //     cost: '200,000', //ຕົ້ນທືນ
    //     profit: '300,000', //ກຳໄລ
    //     exchange: '1' //ແລກປ່ຽນ
    //     },
    //     {
    //     currency: 'ບາດ',
    //     total: '100',
    //     notYetPaid: '50',
    //     paid: '50',
    //     cost: '20',
    //     profit: '30',
    //     exchange: '622.02'
    //     },
    //     {
    //     currency: 'ໂດລາ',
    //     total: '100',
    //     notYetPaid: '50',
    //     paid: '50',
    //     cost: '20',
    //     profit: '30',
    //     exchange: '21,483.00'
    //     },
    //     {
    //     currency: 'ລວມເປັນກີບ',
    //     total: '3,210.502',
    //     notYetPaid: '1,605,451',
    //     paid: '1,605,451',
    //     cost: '642,100.4',
    //     profit: '963,150.6',
    //     exchange: '1'
    //     }
    // ];

    return (
        <Table responsive striped bordered hover>
            <thead className="bg-light">
            <tr>
                <th style={{ minWidth: '120px', color: '#0d6efd'}}></th>
                <th style={{ minWidth: '120px', color: '#0d6efd' }}>ຍອດທັງໝົດ</th>
                <th style={{ minWidth: '120px', color: '#0d6efd' }}>ຍັງບໍ່ທັນຊຳລະ</th>
                <th style={{ minWidth: '120px', color: '#0d6efd' }}>ຊຳເລັດແລ້ວ</th>
                <th style={{ minWidth: '120px', color: '#0d6efd' }}>ຕົ້ນທືນ</th>
                <th style={{ minWidth: '120px', color: '#0d6efd' }}>ກຳໄລ</th>
                <th style={{ minWidth: '120px', color: '#0d6efd' }}>ແລກປ່ຽນ</th>
            </tr>
            </thead>
            <tbody>
            {_.isEmpty(tableData)? (
                <tr>
                    <td colSpan={7} className="text-center">
                    {loadingSummaryMoney ? 'ກໍາລັງໂຫຼດ...' : 'ບໍ່ພົບຂໍ້ມູນ'}
                    </td>
                </tr>
                // <p style={{ textAlign: 'center' }}>{loadingSummaryMoney ? 'ກໍາລັງໂຫຼດ...' : 'ບໍ່ພົບຂໍມູນ'}</p>
                ) : (tableData.map((row, index) => (
                <tr key={index}>
                <td style={{ color: '#0d6efd' }}>{row?.currency}</td>
                <td>{row?.total.toLocaleString('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                })}</td>
                <td>{row?.notYetPaid.toLocaleString('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                })}</td>
                <td>{row?.paid.toLocaleString('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                })}</td>
                <td>{row?.cost.toLocaleString('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                })}</td>
                <td>{row?.profit.toLocaleString('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                })}</td>
                <td>{row?.exchange.toLocaleString('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                })}</td>
                </tr>
            )))}
            </tbody>
        </Table>
    );
};

export default SummaryMoney;